import { useInfiniteQuery } from 'hooks/useInfiniteQuery'

import { fetchCoaches } from 'utils/queries'

import { UserType } from 'types/user'

export const useCoaches = () => {
  return useInfiniteQuery<Array<UserType>>(
    ['coaches'],
    async ({ pageParam }) => {
      const coaches = await fetchCoaches({
        order: 'firstName',
        orderDirection: 'asc',
        lastVisible: pageParam,
        limit: 10,
      })
      return coaches.filter((coach) => coach.username !== undefined)
    },
    {
      getNextPageParam: (lastPage) => {
        // Very important, as the last page might not have any results
        if (!lastPage || !lastPage.length || lastPage.length < 6) return undefined

        return lastPage[lastPage.length - 1].firstName
      },
    },
  )
}
